<template>
  <div class="container">

      <AutosLista></AutosLista>

  </div>
</template>

<script>
import AutosLista from '../components/AutosLista.vue';

export default {
    name:'Autos',
    
    components:{
        AutosLista
    }
    
}
</script>

<style>

</style>